import React, { Component } from 'react';
import { Form, DatePicker } from 'antd';
import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';
import util from '@/api/util';
function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
}
// function disabledDateTime() {
//     return {
//         disabledSeconds: () => range(1, 60),
//     };
// }
class DatePickerHour extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultValue: '',
            className: props.className ? props.className : ''
        }
    }

    componentDidMount() {
        const { feild, setValue, format, type, initialValue } = this.props;
        console.log(initialValue)
        // if (!initialValue) {
        //     setValue(feild, moment(util.formatTimestamp((new Date()).getTime()), format));
        // };
    }

    render() {
        const { className } = this.state
        const { format, setValue, type, showTimeFlag, width, feild, initialValue, disabledDate, disabled } = this.props;
        console.log(initialValue)
        const { defaultValue } = this.state;
        const renderDom = () => {
            return (
                <DatePicker
                    className={className}
                    placeholder="设置结束时间"
                    // showTime={showTimeFlag}
                    showTime={{ format: 'HH:mm' }}
                    format={format}
                    locale={locale}
                    size='small'
                    // disabledTime={disabledDateTime}
                    // defaultValue={initialValue && moment(initialValue, format)}
                    defaultValue={initialValue && moment(initialValue, format)}
                    style={{ width: width ? width : "240px", minWidth: "100px" }}
                    onChange={(date, dateString) => {
                        setValue(feild, date)
                    }}
                />
            )
        }
        return (
            renderDom()
        )
    }
}


export default DatePickerHour
